

































































































import { Component, Vue } from "vue-property-decorator";
// Service methods
import { getAllDesignButtonStyles } from "@/services/styles/designButtonStylesService";

// Types
import { designButtonStyleFields } from "@/components/styles/fields/stylesFields";
import { DesignButtonStyle } from "@/services/styles/types";

// Components
import DesignButtonStyleDeleteModal from "@/components/styles/modals/DesignButtonStyleDeleteModal.vue";
import DesignButtonStyleCopyModal from "@/components/styles/modals/DesignButtonStyleCopyModal.vue";

@Component({
    components: { DesignButtonStyleDeleteModal, DesignButtonStyleCopyModal }
})
export default class DesignButtonStyles extends Vue {
    designButtonStyles: DesignButtonStyle[] = [];
    searchQuery = "";
    filterCode = "";
    fields = designButtonStyleFields;
    isBusy = false;

    // Lifecycle hooks
    created() {
        this.fetchData();
    }

    // Computed
    get filteredData() {
        return this.designButtonStyles.filter(x => (this.searchQuery === "" ? true : x.name.toLowerCase().includes(this.searchQuery.toLowerCase())) &&
                (this.filterCode === "" ? true : JSON.stringify(x.css).toLowerCase().includes(this.filterCode.toLowerCase())));
    }

    // Methods
    updateDesignButtonStyleRoute(id: string) {
        return {
            name: "updateDesignButtonStyles",
            params: { designButtonStyleId: id }
        };
    }

    deleteStyle(styleId: string, name: string) {
        (this.$refs.designButtonStyleDeleteModal as any).open(styleId, name);
    }

    copyStyle(id: string, name: string) {
        (this.$refs.designButtonStyleCopyModal as any).open(id, name);
    }

    clearFilter() {
        this.filterCode = "";
        this.loadDesignButtonStyles();
    }

    loadDesignButtonStyles() {
        getAllDesignButtonStyles().then((response: any) => {
            this.designButtonStyles = response;
            this.isBusy = false;
        });
    }

    fetchData() {
        this.isBusy = true;
        this.loadDesignButtonStyles();
    }
}
